import React from 'react'
import { Grid, Button } from '@material-ui/core'

import { List } from '../trabalhos/components'

import { useTitle } from 'utils'
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  card: {
    position: 'relative',
    height: 512,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: (theme.palette.type === 'dark') ? '#333' : '#fff',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  },
}))

const listLayout = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 6,
  xl: 6
}

function BookMarksPage({ bookmarks, handleBookmarksButton, handleShowNotification }) {
  const classes = useStyles()
  useTitle('PSE-2019 | Bookmarks')


  return (
    <>
      <div className={classes.container}>
      <Grid container spacing={32} style={{ marginTop: '5px' }}>
        {bookmarks.length > 0 ? (bookmarks.map((work, key) => (
          <Grid item key={`${key}-${work.ID}`} {...listLayout} style={{ padding: '5px 5px' }}>
            <List {...work} bookmarked={work.bookmarked}
              handleBookmarksButton={handleBookmarksButton}
            />
          </Grid>
        ))) : (
          <>
            <p style={{ width: '100%', textAlign: 'center' }}>Currently your bookmark list is empty.</p>
            <p style={{ width: '100%', textAlign: 'center' }}>You can select in the List of Contributions.</p>
          </>
        )
        }
      </Grid>
    </div>
    </>
  )
}

export default BookMarksPage
